module.exports = __webpack_public_path__ + "static/media/RPR 1c1.062d8758.jpg";